import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=a4a2b862&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a2b862')) {
      api.createRecord('a4a2b862', component.options)
    } else {
      api.reload('a4a2b862', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=a4a2b862&", function () {
      api.rerender('a4a2b862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W4M5RXCkfo4c/JS/comp/pricelist.vue"
export default component.exports